import http from "@/helper/http";

const initialState = () => ({
  groups: [],
  loading: false,
  total: 0,
  currentPage: 1,
  perPage: 20,
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    SET_GROUPS(state, { items, total }) {
      state.groups = items || [];
      state.total = total || 0;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_PAGE(state, page) {
      state.currentPage = page;
    },
    RESET_STATE(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    async fetchGroups({ commit, state }, params = {}) {
      commit("SET_LOADING", true);
      try {
        const response = await http.get("/v2/groups", {
          params: {
            page: state.currentPage,
            per_page: state.perPage,
            ...params,
          },
        });
        const data = response?.data || {};
        commit("SET_GROUPS", {
          items: data.items || [],
          total: data.total || 0,
        });
        return data;
      } finally {
        commit("SET_LOADING", false);
      }
    },
    async createGroup(_, payload) {
      const response = await http.post("/v2/groups", payload);
      return response?.data;
    },
    async updateGroup(_, { groupId, payload }) {
      const response = await http.patch(
        `/v2/groups/${groupId}`,
        payload
      );
      return response?.data;
    },
    async deleteGroup(_, groupId) {
      const response = await http.delete(`/v2/groups/${groupId}`);
      return response?.data;
    },
    async generateJoinCode(_, { groupId, payload }) {
      const response = await http.post(
        `/v2/groups/${groupId}/join-code`,
        payload
      );
      return response?.data;
    },
  },
  getters: {
    groups: (state) => state.groups,
    loading: (state) => state.loading,
    total: (state) => state.total,
    currentPage: (state) => state.currentPage,
    perPage: (state) => state.perPage,
  },
};
